/* global swal angular   */
import './style.less';
import moment from 'moment-timezone';
import modalTemplate from 'modals/marketplace/template.html';
import modalController from 'modals/marketplace/controller';
import { get } from 'lodash';


export default function($q, $state, $log, $timeout, $compile, $scope, $uibModal, $filter, uiCalendarConfig, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;
  vm.eventSources = [];

  const { company_id } = ProfileClass;
  const removeOwnEvents = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.removeOwnEvents');

  vm.uiConfig = {
    calendar: {
      height: '100%',
      editable: false,
      header: {
        left: 'title',
        center: '',
        right: 'today agendaDay agendaWeek month prev,next'
      },
      eventClick: openEvent,
      eventRender: eventRender
    }
  };

  function openEvent(event) {
    $uibModal
      .open({
        template: modalTemplate,
        controller: modalController(event),
        size: 'lg',
        backdrop: true
      })
      .result.catch(error => {
        if (error === 'cancel' || error === 'backdrop click') return;
        $log.error(error);
      });
  }

  function eventRender(event, element, view) {
    let toolTipText = `${event.name || event.course_name} <br/> ${$filter('DeliveryMethod')(
      event.delivery_method
    )}`.replace(/'/g, "\\'");

    if (event.delivery_date) {
      toolTipText += `<br/> ${$filter('PrettyDateTime')(event.delivery_date, event.timeZoneId)}`;
    }

    element.attr({
      'uib-tooltip-html': `'<p>${toolTipText}</p>'`,
      'tooltip-append-to-body': true
    });
    $compile(element)($scope);
  }

  function activate() {
    vm.eventSources.length = 0;
    if (!vm.events) return;
    vm.loaded = false;
    vm.events.forEach(event => {
      delete event.url;
      event.id = event.event_id;
      event.color = '#2F4050';
      event.overlap = false;
      event.title = event.course_name;

      const startTime = event.delivery_date || event.start_time;
      const delStartTime = moment(startTime).tz('America/New_York');
      event.start = new Date(delStartTime);

      const endTime = event.delivery_end_date || event.end_time;
      const delEndTime = moment(endTime).tz('America/New_York');
      event.end = new Date(delEndTime);

      if (event.delivery_method === 1) event.color = '#FFC107';
      if (event.delivery_method === 2) event.color = '#2196F3';
      if (!event.link && event.status !== 'register') event.color = '#8BC34A';
      if (event.link) event.color = '#483F89';
    });

    if (removeOwnEvents) {
      vm.events = vm.events.filter(({company_id: course_company_id, vendor_id}) => course_company_id != company_id && vendor_id != company_id);
    }

    vm.eventSources.push(vm.events);
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/marketplaceCalendar/controller.js